import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postHomeFormTwoStart,
  postHomeFormTwoSuccess,
  postHomeTwoDataSuccess,
  postHomeFormTwoFailure,
} from "../reducers/postHomeFormTwoReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postHomeFormTwo = createAsyncThunk(
  "postHomeFormTwo",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postHomeFormTwoStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Home/SaveHomeSecondPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postHomeFormTwoSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postHomeTwoDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postHomeFormTwoFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postHomeFormTwoFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postHomeFormTwoFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
